module.exports = __webpack_public_path__ + "static/media/boneco-git.2111879a.gif";